import type { ReactNode } from 'react';
import { Box, Divider } from '@zillow/constellation-10';
import { LoadingHeading, LoadingText } from '@zg-rentals/loading-components';
import { ExperianLogo } from '../CreditReport/components/CreditReportHeader';
import { CicLogo } from '../BackgroundReport/components/BackgroundReportHeader';
import { ReportType } from '../models/report-models';

const REPORT_LOGOS: Partial<Record<ReportType, ReactNode>> = {
  [ReportType.CreditReport]: <ExperianLogo />,
  [ReportType.LegacyCreditReport]: <ExperianLogo />,
  [ReportType.BackgroundReport]: <CicLogo />,
  [ReportType.LegacyBackgroundReport]: <CicLogo />,
};

export function ReportLoading({ reportType }: { reportType?: ReportType }) {
  const logo = reportType ? REPORT_LOGOS[reportType] : undefined;

  return (
    <>
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <LoadingHeading isLoading css={{ marginBottom: 'default' }} level={2}>
            Loading
          </LoadingHeading>
          <LoadingText isLoading css={{ marginBottom: 'default' }}>
            Loading
          </LoadingText>
        </Box>
        {logo && (
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 'loose',
              marginLeft: 'looser',
            }}
          >
            {logo}
          </Box>
        )}
      </Box>
      <Divider css={{ marginBottom: 'default', marginTop: 'default' }} />
      <LoadingText isLoading css={{ marginBottom: 'looser' }}>
        Loading
      </LoadingText>
      <LoadingText isLoading>Loading</LoadingText>
    </>
  );
}
